<template lang="html">
  <v-layout column class="px-2 auto-shrink">
    <iframe id="my_iframe" style="display:none;"></iframe>
    <v-layout v-if="loading">
      <v-progress-circular
        indeterminate
        color="primary"
        class="mx-auto"
      ></v-progress-circular>
    </v-layout>
    <v-layout column v-else class="auto-shrink">
      <v-layout align-center>
        <v-alert
          :value="true"
          color="error"
          outline
          class="mb-2 text-xs-left"
          v-if="
            isEmpty(selectedEntity && selectedEntity.tax_return_id) &&
              hasUltraTax
          "
        >
          You cannot export tax documents for taxpayer until you have entered
          the {{ hasUltraTax || hasDrake ? 'taxpayer SSN' : 'tax return ID' }}.
        </v-alert>
        <v-alert
          :value="true"
          color="info"
          outline
          class="mb-2 text-xs-left"
          v-else-if="isEmpty(selectedEntity.spouse_ssn) && hasUltraTax"
        >
          You cannot export tax documents for spouse until you have entered the
          spouse SSN.
        </v-alert>
        <v-spacer />
        <v-flex shrink class="mx-2">
          <span class="caption mr-2"
            >{{
              hasUltraTax || hasDrake
                ? 'Taxpayer SSN'
                : 'Tax Software Return ID'
            }}:</span
          >
          <v-layout align-center v-if="editingTaxReturnID">
            <v-text-field
              :placeholder="hasUltraTax || hasDrake ? '123456789' : 'JOHNSMITH'"
              v-model="selectedEntity && selectedEntity.tax_return_id"
              solo
              hide-details
              class="default-input"
            />
            <v-tooltip bottom class="mx-2">
              <i
                class="material-icons-outlined success--text"
                style="font-size: 20px; cursor: pointer"
                @click="saveEntity()"
                slot="activator"
              >
                check
              </i>
              <span>Save</span>
            </v-tooltip>
            <v-tooltip bottom class="ml-2">
              <i
                class="material-icons-outlined error--text"
                style="font-size: 20px; cursor: pointer"
                @click="editingTaxReturnID = false"
                slot="activator"
              >
                cancel
              </i>
              <span>Cancel</span>
            </v-tooltip>
          </v-layout>

          <v-layout align-center v-else>
            <span
              v-if="isEmpty(selectedEntity && selectedEntity.tax_return_id)"
              class="darkgrey--text"
              >Blank</span
            >
            <span v-else>{{
              selectedEntity && selectedEntity.tax_return_id
            }}</span>
            <v-tooltip bottom class="ml-2">
              <i
                class="material-icons-outlined primary--text"
                style="font-size: 20px; cursor: pointer"
                @click="editTaxReturnId()"
                slot="activator"
              >
                edit
              </i>
              <span>Edit</span>
            </v-tooltip>
          </v-layout>
        </v-flex>
        <v-flex shrink class="mx-2" v-if="hasUltraTax">
          <span class="caption mr-2">Spouse SSN:</span>
          <v-layout v-if="editingSpouseSSN" align-center>
            <v-text-field
              placeholder="123456789"
              v-model="selectedEntity.spouse_ssn"
              solo
              hide-details
              class="default-input"
            />
            <v-tooltip bottom class="mx-2">
              <i
                class="material-icons-outlined success--text"
                style="font-size: 20px; cursor: pointer"
                @click="saveEntity()"
                slot="activator"
              >
                check
              </i>
              <span>Save</span>
            </v-tooltip>
            <v-tooltip bottom class="ml-2">
              <i
                class="material-icons-outlined error--text"
                style="font-size: 20px; cursor: pointer"
                @click="editingSpouseSSN = false"
                slot="activator"
              >
                cancel
              </i>
              <span>Cancel</span>
            </v-tooltip>
          </v-layout>

          <v-layout align-center v-else>
            <span
              v-if="isEmpty(selectedEntity.spouse_ssn)"
              class="darkgrey--text"
              >Blank</span
            >
            <span v-else>{{ selectedEntity.spouse_ssn }}</span>
            <v-tooltip bottom class="ml-2">
              <i
                class="material-icons-outlined primary--text"
                style="font-size: 20px; cursor: pointer"
                @click="editSpouseSSN()"
                slot="activator"
              >
                edit
              </i>
              <span>Edit</span>
            </v-tooltip>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout
        align-center
        v-if="!showLeadsheet"
        class="auto-shrink filter-container"
      >
        <v-flex>
          <div class="text-xs-left">Search</div>
          <v-text-field
            v-model="search"
            class="default-input subheading"
            solo
            hide-details
            placeholder="Look for Document"
          />
        </v-flex>
        <v-spacer />
        <v-flex shrink class="pr-2">
          <div class="text-xs-left">Hide Unreviewed</div>
          <v-switch
            v-model="reviewedFilter"
            hide-details
            solo
            class="default-input body-1 my-0 py-0"
          />
        </v-flex>
        <v-flex shrink class="px-1">
          <div class="text-xs-left">Status</div>
          <v-select
            v-model="statusFilter"
            :items="statusTypes"
            hide-details
            class="default-input body-1"
            solo
            small
            style="max-width: 120px"
          />
        </v-flex>
        <v-flex shrink class="px-1">
          <v-btn
            color="primary"
            class="default-input mx-0 text-none"
            @click="scheduleMultipleDocuments"
            :disabled="selectedDocuments.length === 0 || !taxIdFilled"
            v-if="!showLeadsheet"
          >
            Schedule for Export
          </v-btn>
        </v-flex>
        <v-flex shrink class="px-1">
          <v-btn
            color="primary"
            class="default-input mx-0 text-none"
            @click="startExportForEntity"
            v-if="!showLeadsheet && showBeginExportButton"
            :disabled="
              documents.filter(doc => doc.export_status === 'scheduled')
                .length === 0
            "
          >
            Begin Export
          </v-btn>
        </v-flex>
      </v-layout>

      <ReviewTaxForms
        :style="showLeadsheet ? '' : 'height: 0px;display: none;'"
        :documents="documents"
        :selected-document.sync="selectedDocument"
        :selected-entity="selectedEntity"
        :selected-year="selectedYear"
        :hideMoveButton="true"
        :hideRotateButton="true"
        :zoom="zoom"
        @refresh="getAllExportableDocumentsForEntity"
        :bigger-view="biggerView"
      />

      <v-data-table
        v-if="!showLeadsheet"
        v-model="selectedDocuments"
        :headers="documentsToExportHeader"
        :items="exportableDocuments"
        :search="search"
        :pagination.sync="documentsToExportPagination"
        :loading="tableLoading"
        :custom-filter="customFilter"
        class="text-xs-left export-table"
        :select-all="$vuetify.breakpoint.mdAndUp"
      >
        <template slot="items" slot-scope="props">
          <tr :key="props.index" slot="header">
            <td class="hidden-sm-and-down">
              <v-checkbox
                v-model="props.selected"
                primary
                hide-details
              ></v-checkbox>
            </td>
            <td class="text-xs-left">
              <v-layout
                align-center
                @click="goToReviewTab(props.item)"
                class="primary--text"
                style="cursor: pointer"
              >
                {{
                  props.item.detailed_name
                    ? props.item.detailed_name
                    : props.item.name
                }}
              </v-layout>
            </td>
            <td class="text-xs-left">
              <v-layout align-center>
                <v-chip
                  small
                  :class="findStatus(props.item.export_status).class"
                >
                  <v-icon
                    class="mr-2"
                    :class="findStatus(props.item.export_status).class"
                    >{{ findStatus(props.item.export_status).icon }}</v-icon
                  >
                  {{ findStatus(props.item.export_status).text }}
                </v-chip>
              </v-layout>
            </td>
            <td class="text-xs-left">
              <span v-if="props.item.reviewer_id"
                >{{ props.item.reviewer_name }} on
                {{ moment(props.item.reviewed_at).format('LL') }}</span
              >
              <span v-else>-</span>
            </td>
            <td class="text-xs-left">
              <span class="grey--text text--darken-1">{{
                moment(props.item.created_at).format('LL')
              }}</span>
            </td>
            <!-- <td class="text-xs-center font-weight-bold">
            <span class="primary--text">{{props.item.failed.length}}</span>
          </td> -->
            <td class="text-xs-center">
              <v-layout align-center justify-end>
                <v-tooltip
                  v-if="props.item.export_status === 'action_required'"
                  bottom
                >
                  <v-btn
                    icon
                    flat
                    color="primary"
                    class="mx-0"
                    @click="createExportTask(props.item)"
                    :disabled="
                      !supportedTaxFormsForDataEntry.includes(
                        props.item.name,
                      ) || !taxIdFilled
                    "
                    slot="activator"
                  >
                    <v-icon
                      class="material-icons-outlined document-action__icon"
                      >play_circle</v-icon
                    >
                  </v-btn>
                  <span
                    v-if="
                      supportedTaxFormsForDataEntry.includes(props.item.name)
                    "
                    >Schedule</span
                  >
                  <span v-else>This form is not yet supported</span>
                </v-tooltip>
                <v-tooltip
                  v-if="props.item.export_status === 'scheduled'"
                  bottom
                >
                  <v-btn
                    icon
                    flat
                    color="error"
                    class="mx-0"
                    @click="deleteExportTask(props.item)"
                    slot="activator"
                  >
                    <v-icon
                      class="material-icons-outlined document-action__icon"
                      >cancel</v-icon
                    >
                  </v-btn>
                  <span>Cancel Export</span>
                </v-tooltip>
                <v-tooltip v-if="showResetButton(props.item)" bottom>
                  <v-btn
                    icon
                    flat
                    color="primary"
                    class="mx-0"
                    @click="deleteExportTask(props.item)"
                    slot="activator"
                  >
                    <v-icon
                      class="material-icons-outlined document-action__icon"
                      >sync</v-icon
                    >
                  </v-btn>
                  <span>Reset</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn
                    icon
                    flat
                    color="error"
                    class="mx-0"
                    @click="deleteExtractedDocument(props.item.id)"
                    slot="activator"
                  >
                    <v-icon
                      class="material-icons-outlined document-action__icon"
                      >delete</v-icon
                    >
                  </v-btn>
                  <span>Delete</span>
                </v-tooltip>
              </v-layout>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-layout>
  </v-layout>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import API from '@/api';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import DataEntryMixin from '@/mixins/DataEntryMixin';
import UtilsMixins from '@/mixins/UtilsMixins';
import { yearOptions } from '@/constants/variables';
import ReviewTaxForms from '@/components/ReviewTaxForms';
import user from '../api/user';

export default {
  name: 'ReviewAndExportForEntity',
  props: {
    selectedEntity: {
      type: Object,
      required: true,
    },
    selectedYear: {
      type: Number,
    },
    showLeadsheet: {
      type: Boolean,
    },
    zoom: {
      type: Boolean,
    },
    biggerView: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ReviewTaxForms,
  },
  mixins: [DataEntryMixin, UtilsMixins],
  data() {
    return {
      yearOptions,
      selectedDocuments: [],
      documents: [],
      selectedDocument: null,
      statusFilter: 'all',
      loading: true,
      tableLoading: true,
      selectedFirms: [],
      selectedFirm: 'All',
      reviewedFilter: false,
      newEntitySSN: '',
      newSpouseSSN: '',
      documentsToExportPagination: {
        sortBy: 'created_at',
        rowsPerPage: 10,
        descending: true,
        page: 1,
        options: [
          {
            text: '10 rows per page',
            value: 10,
          },
          {
            text: '20 rows per page',
            value: 20,
          },
          {
            text: '30 rows per page',
            value: 30,
          },
        ],
      },
      selectAll: false,
      exportTasks: [],
      firmList: [],
      search: '',
      selectedFirmId: null,
      timer: null,
      selectedEntityType: 'All',
      entityTypes: [],
      relatedList: null,
      firmIds: [],
      editingTaxReturnID: false,
      editingSpouseSSN: false,
      newEntitySSN: '',
      newSpouseSSN: '',
      activeTab: 0,
      taskTypes: [
        {
          key: 'update_return',
          text: 'Update Return',
        },
        {
          key: 'add_forms',
          text: 'Questionnaire Export',
        },
        {
          key: 'create_return',
          text: 'Create Return',
        },
      ],
    };
  },
  computed: {
    ...mapState('companies', ['companies']),
    ...mapGetters({
      currentUser: 'user',
      currentFirm: 'currentFirm',
    }),
    documentsToExportHeader() {
      return [
        {
          text: 'Document Name',
          align: 'left',
          sortable: true,
          value: 'detailed_name',
          width: '40%',
        },
        {
          text: 'Status',
          align: 'left',
          sortable: true,
          value: 'status',
          width: '20%',
        },
        {
          text: 'Reviewed by',
          align: 'left',
          sortable: true,
          value: 'reviewer_name',
          width: '25%',
        },
        {
          text: 'Uploaded at',
          align: 'left',
          sortable: true,
          value: 'created_at',
          width: '15%',
        },
        {
          text: 'Actions',
          align: 'left',
          value: '',
          width: '10%',
        },
      ].filter(Boolean);
    },
    exportableDocuments() {
      return this.documents.filter(t => this.preorderedForms.includes(t.name));
    },
  },
  methods: {
    isEmpty,
    moment,

    editTaxReturnId() {
      this.editingTaxReturnID = true;
      this.newEntitySSN =
        this.selectedEntity && this.selectedEntity.tax_return_id;
    },

    editSpouseSSN() {
      this.editingSpouseSSN = true;
      this.newSpouseSSN = this.selectedEntity.spouse_ssn;
    },

    async saveEntity() {
      const { id, tax_return_id, spouse_ssn } = this.selectedEntity;

      if (spouse_ssn && spouse_ssn.length !== 9) {
        this.$store.dispatch('application/setErrorNotification', {
          message: 'Spouse SSN must be 9 digits',
        });
        return;
      } else if (
        tax_return_id &&
        tax_return_id.length !== 9 &&
        (this.hasUltraTax || this.hasDrake)
      ) {
        this.$store.dispatch('application/setErrorNotification', {
          message: 'Taxpayer SSN must be 9 digits',
        });
        return;
      }

      try {
        const response = await API.company.updateCompany({
          tax_return_id,
          spouse_ssn,
          id,
          userId: this.selectedEntity.user.id,
        });

        if (response.data.error) {
          console.log(response.data.error);
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
          });
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: `Information has been saved successfully`,
          });
          await this.$store.dispatch('companies/getCompanies');
        }
      } catch (e) {
        console.log(e);
        if (get(e, 'response.data.error', false)) {
          this.$store.dispatch('application/setErrorNotification', {
            message: e,
          });
        }
      } finally {
        this.editingSpouseSSN = false;
        this.editingTaxReturnID = false;
      }
    },

    showResetButton(document) {
      return (
        document.export_status === 'failed' ||
        document.export_status === 'completed' ||
        (['in_progress', 'in_qa', 'system_failure'].includes(
          document.export_status,
        ) &&
          this.getIsSorabanAdvisorAdmin(this.currentUser))
      );
    },

    deleteExportTask(document) {
      document.status = 'action_required';
      document.export_status = 'action_required'; // automatically deletes in backend
      this.updateExtractedDocument(document);
    },

    createExportTask(document) {
      document.status = 'scheduled';
      document.export_status = 'scheduled';
      this.updateExtractedDocument(document);
    },

    goToReviewTab(document) {
      this.selectedDocument = document;
      this.$emit('update:show-leadsheet', true);
      this.$emit('update:review-and-export-tab', 0);
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    customFilter(items, search) {
      const searchedItem = search.toLowerCase();
      return items.filter(row => {
        let rowExists = true;
        if (searchedItem.length) {
          rowExists = row.name.toLowerCase().includes(searchedItem);
        }
        if (this.statusFilter !== 'all' && rowExists) {
          rowExists = row.export_status === this.statusFilter;
        }
        if (this.reviewedFilter && rowExists) {
          rowExists = !row.reviewer_id;
        }
        return rowExists;
      });
    },
    removeExportTaskAssociation(document) {
      document.export_task_id = null;
      this.updateExtractedDocument(document);
    },
    async scheduleMultipleDocuments() {
      try {
        this.tableLoading = true;
        this.asyncForEach(this.selectedDocuments, async document => {
          if (this.supportedTaxFormsForDataEntry.includes(document.name)) {
            document.status = 'scheduled';
            document.export_status = 'scheduled';
            this.updateExtractedDocument(document);
          }
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.tableLoading = false;
        this.getAllExportableDocumentsForEntity();
        this.selectedDocuments = [];
      }
    },

    async deleteExtractedDocument(id) {
      if (!confirm('Delete this file?')) return;

      try {
        const response = await API.extractedDocument.deleteExtractedDocument(
          id,
        );
        if (response.data.error) {
          console.log(response.data.error);
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: 'Successfully deleted.',
          });
          this.getAllExportableDocumentsForEntity();
        }
      } catch (e) {
        console.log(e);
      }
    },

    async getAllExportableDocumentsForEntity() {
      try {
        this.tableLoading = true;
        const response = await API.company.getAllExportableDocumentsForEntity({
          id: this.selectedEntity.id,
          year: this.selectedYear,
        });
        if (response.data.error) {
          console.log(response.data.error);
        } else {
          this.documents = response.data;
          if (!this.selectedDocument) {
            this.selectedDocument = this.documents[0];
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.tableLoading = false;
      }
    },

    async startExportForEntity() {
      try {
        const response = await API.exportTask.startExportForEntity({
          companyId: this.selectedEntity.id,
          year: this.selectedYear,
        });
        if (response.data.error) {
          console.log(response.data.error);
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: 'Export started successfully.',
          });
        }

        this.getAllExportableDocumentsForEntity();
      } catch (error) {
        console.error(error);
        this.$store.dispatch('application/setErrorNotification', {
          message: error,
        });
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  async created() {
    this.loading = true;
    await this.getAllExportableDocumentsForEntity();

    this.loading = false;
  },
  watch: {
    selectedYear() {
      this.selectedDocument = null;
      this.$emit('update:showLeadsheet', true);
      this.getAllExportableDocumentsForEntity();
    },
    showLeadsheet: {
      handler(show) {
        if (show && !this.selectedDocument) {
          this.selectedDocument = this.documents[0];
        }
      },
    },
    selectedEntity: {
      handler() {
        this.loading = true;
        this.selectedDocument = null;
        this.$emit('update:showLeadsheet', true);
        this.getAllExportableDocumentsForEntity();
        this.loading = false;
      },
    },
  },
};
</script>

<style lang="css">
.filter-container {
  flex-shrink: 0;
}
.export-table {
  overflow: auto;
}
.user-panel {
  border: 1px solid #bdbdbd;
}
.notification__text {
  color: #616161;
  font-size: 14px;
}
.notification__time {
  color: #757575;
}
.users-overview-data-table tbody td:nth-child(2),
.users-overview-data-table tbody td:nth-child(5) {
  padding-left: 5px;
  padding-right: 5px;
}
.users-overview-data-table tbody td:nth-child(7) {
  padding-left: 0px;
  padding-right: 5px;
}
.settings__container {
  max-width: 1100px;
}
.bordered {
  border: 1px solid #bdbdbd;
}
.v-tab-item {
  display: flex !important;
  justify-content: center;
}

.tabs {
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.tabs >>> .v-tabs__container {
  height: 60px;
}

.tabs >>> .v-tabs__item {
  text-transform: none;
  font-weight: bold;
  font-size: 18px;
  padding: 24px 24px;
}

.tabs >>> .v-tabs__slider-wrapper {
  top: 0;
}

.tabs >>> .v-tabs__slider {
  height: 4px;
}
</style>
